(function () {
  if (!document.body.classList.contains('template-anogen-lp')) return;

  /* 人気セクション：左右ナビ */
  document.querySelectorAll('[data-anogen-pop]').forEach(function (wrap) {
    var strip = wrap.querySelector('[data-anogen-pop-strip]');
    var prev = wrap.querySelector('[data-anogen-pop-prev]');
    var next = wrap.querySelector('[data-anogen-pop-next]');
    if (!strip || !prev || !next) return;

    function step() {
      var card = strip.querySelector('.anogen-pcard');
      var gap = parseInt(getComputedStyle(strip).columnGap || getComputedStyle(strip).gap || 16, 10) || 16;
      return card ? card.getBoundingClientRect().width + gap : Math.round(strip.clientWidth * 0.8);
    }

    function update() {
      var max = strip.scrollWidth - strip.clientWidth - 2;
      prev.hidden = strip.scrollLeft <= 4;
      next.disabled = strip.scrollLeft >= max;
      prev.disabled = strip.scrollLeft <= 4;
    }

    next.addEventListener('click', function () {
      strip.scrollBy({ left: step(), behavior: 'smooth' });
    });
    prev.addEventListener('click', function () {
      strip.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    strip.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* タイアップモーダル */
  var modal = document.querySelector('[data-anogen-tie-modal]');
  if (modal) {
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    var grid = modal.querySelector('[data-anogen-tie-modal-grid]');
    var nameEl = modal.querySelector('[data-anogen-tie-modal-name]');
    var closeBtn = modal.querySelector('[data-anogen-tie-modal-close]');

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function openModal(name, panels) {
      nameEl.textContent = name;
      grid.style.setProperty('--tie-count', Math.max(panels.length, 1));
      // 7枚以上は2段に折り返す
      var rows = panels.length > 6 ? 2 : 1;
      grid.style.setProperty('--tie-cols', Math.max(Math.ceil(panels.length / rows), 1));
      grid.style.setProperty('--tie-rows', rows);
      grid.innerHTML = panels
        .map(function (src) {
          return '<img src="' + src + '" alt="' + name + ' パネル" loading="lazy">';
        })
        .join('');
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    document.querySelectorAll('[data-anogen-tie-card]').forEach(function (card) {
      card.addEventListener('click', function () {
        var panels = [];
        try {
          panels = JSON.parse(card.getAttribute('data-panels') || '[]');
        } catch (e) {
          panels = [];
        }
        openModal(card.getAttribute('data-name') || '', panels);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  /* 人気パネル：拡大ポップアップ */
  var popModal = document.querySelector('[data-anogen-pop-modal]');
  if (popModal) {
    if (popModal.parentNode !== document.body) document.body.appendChild(popModal);
    var popGrid = popModal.querySelector('[data-anogen-pop-modal-grid]');
    var popClose = popModal.querySelector('[data-anogen-pop-modal-close]');

    function closePop() {
      popModal.classList.remove('is-open');
      popModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function openPop(src, name) {
      if (!src) return;
      popGrid.innerHTML = '<img src="' + src + '" alt="' + (name || '') + '" loading="lazy">';
      popModal.classList.add('is-open');
      popModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    document.querySelectorAll('[data-anogen-pop-card]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openPop(btn.getAttribute('data-pop-src'), btn.getAttribute('data-pop-name'));
      });
    });

    if (popClose) popClose.addEventListener('click', closePop);
    popModal.addEventListener('click', function (e) {
      if (e.target === popModal) closePop();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePop();
    });
  }

  /* ニュース：ページ送り */
  document.querySelectorAll('[data-news-root]').forEach(function (root) {
    var pager = root.querySelector('[data-news-pager]');
    if (!pager) return;
    var itemEls = root.querySelectorAll('.anogen-news__item');
    var pageBtns = pager.querySelectorAll('[data-news-page-btn]');
    var prev = root.querySelector('[data-news-prev]');
    var next = root.querySelector('[data-news-next]');
    var pageCount = pageBtns.length;
    var current = 1;

    function showPage(p) {
      current = Math.min(Math.max(p, 1), pageCount);
      itemEls.forEach(function (li) {
        var pg = parseInt(li.getAttribute('data-news-page') || '1', 10);
        li.classList.toggle('anogen-news__item--hidden', pg !== current);
      });
      pageBtns.forEach(function (b) {
        var active = parseInt(b.getAttribute('data-news-page-btn'), 10) === current;
        b.classList.toggle('is-active', active);
        if (active) {
          b.setAttribute('aria-current', 'true');
        } else {
          b.removeAttribute('aria-current');
        }
      });
      if (prev) prev.disabled = current <= 1;
      if (next) next.disabled = current >= pageCount;
    }

    pageBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        showPage(parseInt(b.getAttribute('data-news-page-btn'), 10));
      });
    });
    if (prev) prev.addEventListener('click', function () { showPage(current - 1); });
    if (next) next.addEventListener('click', function () { showPage(current + 1); });

    showPage(1);
  });

  /* スクロール出現 */
  var items = document.querySelectorAll('.anogen-reveal');
  if (!('IntersectionObserver' in window) || !items.length) {
    items.forEach(function (el) {
      el.classList.add('is-in');
    });
    return;
  }
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );
  items.forEach(function (el) {
    io.observe(el);
  });
})();
